import type { ClauseValue } from '@gonfalon/clauses/types';
import { pluralize } from '@gonfalon/format/pluralize';
import type { List } from '@gonfalon/immutable-shim/immutableShim';

import type { Clause } from '#utils/clause/records/Clause';
import { ClauseInstructionKind } from '#utils/instructions/clauses/constants';

import { ClauseInstructionDescription } from './ClauseInstructionDescription';

export type ClauseValueInstructionEntryProps = {
  projKey: string;
  envKey: string;
  clause: Clause;
  values: List<ClauseValue>;
  kind: ClauseInstructionKind.ADD_VALUES_TO_CLAUSE | ClauseInstructionKind.REMOVE_VALUES_FROM_CLAUSE;
};

export const ClauseValueInstructionEntry = ({
  projKey,
  envKey,
  clause,
  values,
  kind,
}: ClauseValueInstructionEntryProps) => {
  let verb, preposition;
  if (kind === ClauseInstructionKind.ADD_VALUES_TO_CLAUSE) {
    verb = 'Add';
    preposition = 'to';
  } else if (kind === ClauseInstructionKind.REMOVE_VALUES_FROM_CLAUSE) {
    verb = 'Remove';
    preposition = 'from';
  }
  return (
    <span data-test-id="clause-value-instruction">
      {verb} {pluralize(values.size, 'value', 'values')}{' '}
      {values.map((value, i) => (
        <span key={i}>
          {i ? ', ' : ''}
          <code>{`${value}`}</code>
        </span>
      ))}{' '}
      {preposition} clause <ClauseInstructionDescription projKey={projKey} envKey={envKey} clause={clause} />
    </span>
  );
};
